import axios from 'axios'
import { ZodError } from 'zod'
import {
  HTTP_STATUS_INTERNAL_SERVER_ERROR,
  HTTP_STATUS_NOT_FOUND,
  HTTP_STATUS_TOO_MANY_REQUESTS,
  HTTP_STATUS_UNAUTHORIZED,
} from 'mixtiles-web-common/consts/httpStatus.const'
import { AICreationError } from 'pages/AICreation/AICreationFlow/consts'

export function getAiWallSubmitErrorCode(error: unknown): string {
  if (error instanceof ZodError) return 'invalid_submit_response'
  const status = axios.isAxiosError(error) ? error.response?.status : undefined
  if (status === undefined) return 'network_error'
  return status === HTTP_STATUS_TOO_MANY_REQUESTS
    ? 'daily_limit'
    : `submit_status_${status}`
}

// No response or a server error: the same request may succeed on a later page load.
export function isTransientAiWallRequestError(error: unknown): boolean {
  if (!axios.isAxiosError(error)) return false
  const status = error.response?.status
  return status === undefined || status >= HTTP_STATUS_INTERNAL_SERVER_ERROR
}

// A transient failure leaves the record generating, so the next page load resumes polling.
export function isTransientAiWallPollError(error: unknown): boolean {
  return (
    isTransientAiWallRequestError(error) ||
    (axios.isAxiosError(error) &&
      error.response?.status === HTTP_STATUS_UNAUTHORIZED)
  )
}

export function getAiWallPollErrorCode(error: unknown): string {
  if (error instanceof AICreationError) return error.errorCode
  if (error instanceof ZodError) return 'invalid_status_response'
  if (axios.isAxiosError(error)) {
    return error.response?.status === HTTP_STATUS_NOT_FOUND
      ? 'job_not_found'
      : 'status_error'
  }
  // pollJobStatusUntilDone's other rejections are its 7-minute limit and an abort, which the job task drops.
  return 'poll_timeout'
}
